import firebase from 'firebase';
import { v4 as uuidv4 } from 'uuid';

export const AUTH_TOKEN_KEY = 'authToken';

export const setupHeaders = (api, token) => {
  api.forEach((instance) => instance.addAuthorization(`Bearer ${token}`));
};

export const setSessionToken = (token: string) => {
  window.localStorage.setItem(AUTH_TOKEN_KEY, token);
};
export const getSessionToken = () => {
  return window.localStorage.getItem(AUTH_TOKEN_KEY);
};
export const removeSessionToken = () => {
  window.localStorage.removeItem(AUTH_TOKEN_KEY);
};

export const setGraphApiSessionToken = (token: string) => {
  window.localStorage.setItem('graphApiAuthToken', token);
};
export const getGraphApiSessionToken = () => {
  return window.localStorage.getItem('graphApiAuthToken');
};
export const setGraphApiSessionTokenExpiryDate = (token: string) => {
  window.localStorage.setItem('graphApiAuthTokenExpiryDate', token);
};
export const getGraphApiSessionTokenExpiryDate = () => {
  return window.localStorage.getItem('graphApiAuthTokenExpiryDate');
};

export const getAnalyticsSessionId = () => {
  const sessionInitTime = window.localStorage.getItem(
    'analyticsSessionInitTime',
  );
  if (!sessionInitTime) {
    const sessionId = uuidv4();
    window.localStorage.setItem('analyticsSessionId', sessionId);
    const now = new Date().toISOString();
    window.localStorage.setItem('analyticsSessionInitTime', now);
    window.localStorage.setItem('analyticsSessionLastAction', now);
    return sessionId;
  }

  const lastActionTime = window.localStorage.getItem(
    'analyticsSessionLastAction',
  );
  const durationBetweenActions =
    new Date().getTime() - new Date(lastActionTime).getTime();

  if (durationBetweenActions > 60 * 5 * 1000) {
    const sessionId = uuidv4();
    window.localStorage.setItem('analyticsSessionId', sessionId);
    const now = new Date().toISOString();
    window.localStorage.setItem('analyticsSessionInitTime', now);
    window.localStorage.setItem('analyticsSessionLastAction', now);
    return sessionId;
  }

  window.localStorage.setItem(
    'analyticsSessionLastAction',
    new Date().toISOString(),
  );
  return window.localStorage.getItem('analyticsSessionId');
};

export const signOut = async () => {
  await firebase.auth().signOut();
  removeSessionToken();
};

export const signIn = async () => {
  const provider = new firebase.auth.OAuthProvider('microsoft.com');
  provider.setCustomParameters({
    tenant: process.env.REACT_APP_AZURE_CREDS_TENANT,
    prompt: 'select_account',
  });
  await firebase.auth().signInWithRedirect(provider);
};
